import { lazy, Suspense } from 'react';
import Navbar from '../home/components/Navbar';
import Hero from './components/Hero';
import Content from './components/Content';
import FAQ from './components/FAQ';
import Footer from '../home/components/Footer';
import { useSchemaOrg, usePageMeta } from '../../utils/seo';

export default function PianoRemovalsLondon() {
  // Set page meta tags
  usePageMeta(
    'Piano Removals London | All 32 Boroughs | From £149',
    'Professional piano removals across all 32 London boroughs. Upright from £149, grand from £320. Fully insured £5M. Same-day available. Free fixed-price quote — 020 3441 9463.',
    'piano removals London, piano removal service London, piano removal cost London, piano removal company London',
    'https://www.pianomovers.co.uk/piano-removals-london',
    'Piano Removals London | All 32 Boroughs | From £149',
    'Professional piano removals across all 32 London boroughs. Upright from £149, grand from £320. Fully insured £5M. Same-day available. Free fixed-price quote — 020 3441 9463.',
    'Piano Removals London | All 32 Boroughs | From £149',
    'Professional piano removals across all 32 London boroughs. From £149. Fully insured £5M. Free fixed-price quote — 020 3441 9463.'
  );

  // Add FAQ structured data
  useSchemaOrg({
    type: 'FAQPage',
    data: {
      mainEntity: [
        {
          '@type': 'Question',
          name: 'How much does piano removal cost in London?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Piano removal costs in London vary depending on the type of piano and specific requirements. Upright piano removals typically start from £149 for straightforward ground‑floor moves within the same borough. Baby grand piano removals begin at £320, while concert grand pianos start from £550. The final cost depends on several factors including the distance of the move, the floor level at both collection and delivery addresses, access challenges such as narrow staircases or tight doorways, and whether any special equipment like crane lifts are required. All reputable piano removal companies in London should provide a fixed‑price quote after assessing your specific situation.',
          },
        },
        {
          '@type': 'Question',
          name: 'How long does a London piano removal take?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'A typical piano removal in London takes between 2 to 4 hours for local moves within the same borough. This includes the time needed for protective wrapping, careful loading, transportation, and placement at the destination. More complex moves involving multiple flights of stairs, difficult access, or longer distances across London may take 4 to 6 hours. Grand piano removals generally require more time due to the need for partial disassembly and reassembly. Your piano removal specialist will provide an accurate time estimate during the initial consultation.',
          },
        },
        {
          '@type': 'Question',
          name: 'Do piano removal companies in London cover all boroughs?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Reputable specialist piano removal companies in London typically cover all 32 London boroughs as part of their standard service area. This includes both inner and outer London locations from Westminster and Camden to Bromley and Havering. Many established piano removal specialists also extend their coverage to the surrounding Home Counties including Essex, Kent, Surrey, and Hertfordshire. When booking your piano removal, always confirm that your specific collection and delivery postcodes are within the company\'s service area to avoid any last‑minute complications.',
          },
        },
      ],
    },
  });

  return (
    <div className="bg-[#f5f5f0] text-[#1a1916]">
      <Navbar />
      <Hero />
      <Content />
      <FAQ />
      <div className="bg-[#1a1916] py-4 text-center">
        <p className="text-[#d4d4ce] text-xs">
          Piano Movers UK is an independent guide to piano removal services in London.
        </p>
      </div>
      <Footer />
    </div>
  );
}
